import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ClassicTextField } from '../Components/ClassicTextField';
import { PasswordTextField } from '../Components/PasswordTextField';
import { SignInLayout } from '../Layout/SignInLayout';
import { openAlert } from '../Store/AlertSlice';
import { SignIn } from '../firebase/Auth/SignIn';

export const SignInPage: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSignIn = async () => {
        try {
            const signedInUser = await SignIn(email, password);

            if (signedInUser !== undefined) {
                signedInUser.getIdTokenResult().then((idTokenResult) => {
                    if (idTokenResult.claims.admin) {
                        navigate('/admin-sessions');
                    }
                });
                navigate('/sessions');
            }
        } catch (err: any) {
            if (err.code === 'auth/invalid-email') {
                dispatch(
                    openAlert({
                        displayText: 'Nesprávná emailová adresa',
                        severity: 'error',
                    }),
                );
            } else {
                dispatch(
                    openAlert({
                        displayText: 'Nelze se přihlásit.',
                        severity: 'error',
                    }),
                );
            }
        }
    };

    const changeEmailHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setEmail(e.currentTarget.value);
    };

    const changePasswordHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setPassword(e.currentTarget.value);
    };

    return (
        <SignInLayout>
            <Typography variant="h4" textAlign="center">
                Přihlásit
            </Typography>
            <ClassicTextField
                label="Email"
                value={email}
                changeValueHandler={changeEmailHandler}
            />
            <PasswordTextField
                label="Heslo"
                value={password}
                setValueHandler={changePasswordHandler}
            />
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    color="secondary"
                    variant="contained"
                    sx={{ width: '100px' }}
                    onClick={handleSignIn}
                >
                    <Typography variant="button" sx={{ fontWeight: 'bold' }}>
                        Přihlásit
                    </Typography>
                </Button>
            </Box>
        </SignInLayout>
    );
};
